import {BaseWrapper} from '../../../allkey/framework/parameters/BaseWrapper';
import {FreeDataValue} from '../message/FreeDataValue';
import {FreeDataValueCriteria} from './FreeDataValueCriteria';
import {FreeDataValueScenario} from './FreeDataValueScenario';

export class FreeDataValueWrapper extends BaseWrapper<FreeDataValue, FreeDataValueCriteria, FreeDataValueScenario>  {}

